/**
 * Blog Category Nav
 * Scroll fade indicators + active item auto-scroll
 */
(function () {
  'use strict';

  function initBlogNav(nav) {
    var scrollContainer = nav.querySelector('.blog-nav__scroll-container');
    var list = nav.querySelector('.blog-nav__categories');
    if (!scrollContainer || !list) return;

    // --- Fade indicators based on scroll position ---
    function updateFades() {
      var scrollLeft = list.scrollLeft;
      var maxScroll = list.scrollWidth - list.clientWidth;

      if (maxScroll <= 2) {
        // No overflow — hide both fades
        scrollContainer.classList.remove('blog-nav__scroll-container--fade-left');
        scrollContainer.classList.remove('blog-nav__scroll-container--fade-right');
        return;
      }

      scrollContainer.classList.toggle(
        'blog-nav__scroll-container--fade-left',
        scrollLeft > 4
      );
      scrollContainer.classList.toggle(
        'blog-nav__scroll-container--fade-right',
        scrollLeft < maxScroll - 4
      );
    }

    list.addEventListener('scroll', updateFades, { passive: true });
    window.addEventListener('resize', updateFades, { passive: true });

    // --- Auto-scroll active item into view on mobile ---
    var activeItem = list.querySelector('.blog-nav__item--active');
    if (activeItem && list.scrollWidth > list.clientWidth) {
      var itemLeft = activeItem.offsetLeft;
      var itemWidth = activeItem.offsetWidth;
      var listWidth = list.clientWidth;
      // Center the active item in the scroll container
      var scrollTarget = itemLeft - (listWidth / 2) + (itemWidth / 2);
      list.scrollLeft = Math.max(0, scrollTarget);
    }

    // Initial fade check (after potential auto-scroll)
    requestAnimationFrame(updateFades);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var navs = document.querySelectorAll('.blog-nav');
    navs.forEach(initBlogNav);
  });
})();
